import React from "react";

export default function Logo({ className = "", withWordmark = true }) {
  return (
    <span className={`zx-logo ${className}`} aria-label="Zyravex">
      <svg
        width="36"
        height="36"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect x="1" y="1" width="38" height="38" rx="9" fill="#0B2A4A" />
        <path
          d="M11 12h18l-14 16h14"
          stroke="#E6C67A"
          strokeWidth="2.6"
          strokeLinecap="square"
          strokeLinejoin="miter"
          fill="none"
        />
        <circle cx="29" cy="12" r="2" fill="#E6C67A" />
      </svg>
      {withWordmark && <span className="zx-logo__wordmark">Zyravex</span>}
    </span>
  );
}
